import useApiQuery from 'shared/hooks/use-api-query';
import {AddressProps} from '../types';
import {CoordinatesProps} from 'shared/types/coordinates';

const useAddressByCoordinates = ({latitude, longitude}: CoordinatesProps) => {
  return useApiQuery<AddressProps>({
    url: `/addresses/reverse-geocoding?latitude=${latitude}&longitude=${longitude}`,
    enabled: false,
  });
};

export default useAddressByCoordinates;
